// Filtrage des listes d'employés pour les selects d'ATTRIBUTION uniquement :
// `filterEmployesGroupe` = groupe `employe` + actifs (mécanicien, dépanneur,
// heures — décision Jordan 30.07.2026) ; `filterEmployesActifs` = actifs
// seuls (caissier, tâches, assignation — décision Jordan 11.08.2026).
//
// ⚠️ Règle « valeur historique » : sur une fiche existante dont l'employé
// assigné est sorti du filtre (désactivé ou hors groupe), le select doit
// ENCORE afficher la valeur enregistrée — sinon la fiche paraît vide et la
// première sauvegarde écraserait la donnée. `_reinjecter` remet donc
// toujours l'employé courant en tête, suffixé « (inactif) » le cas échéant.
//
// À NE PAS utiliser pour les filtres de RECHERCHE (qui doivent couvrir tout
// l'historique) ni pour les lookups d'affichage par id (PDF, tableaux).

export const GROUPE_EMPLOYE = "employe"

const _reinjecter = (liste, actifs, currentId) => {
	const id = parseInt(currentId, 10)
	if (!id) return actifs
	if (actifs.some((e) => e.id === id)) return actifs
	const courant = liste.find((e) => e.id === id)
	if (!courant) return actifs
	const entry =
		courant.actif === false
			? { ...courant, nom: `${courant.nom} (inactif)` }
			: courant
	return [entry, ...actifs]
}

export const filterEmployesGroupe = (
	employes,
	currentId,
	groupe = GROUPE_EMPLOYE,
) => {
	const liste = employes || []
	const membres = liste.filter(
		(e) => e.actif !== false && (e.groups || []).includes(groupe),
	)
	return _reinjecter(liste, membres, currentId)
}

export const filterEmployesActifs = (employes, currentId) => {
	const liste = employes || []
	const actifs = liste.filter((e) => e.actif !== false)
	return _reinjecter(liste, actifs, currentId)
}
